/*
* Attendance 
*/
import React from "react";
import MetaTags from "react-meta-tags";
import { Col, Row, Card, Typography, Select, Button, Table } from "antd";
import { useState, useEffect, useRef } from "react";
import moment from "moment";
import "../Attendence/index.css";
import { DownloadOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import BreadcrumbComponent from "../../components/BreadCrumb";
import * as action from "../../store/Attendence/actions";
import { isEmpty } from "lodash";
import { toast, ToastContainer } from "react-toastify";
import api from "../../helpers";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
dayjs.extend(duration);
const BCrumb = [{ to: "/", title: "Home" }, { title: "Attendence" }];

const AttendenceDetails = () => {
  const dispatch = useDispatch();
  //initial api call
  useEffect(() => {
    dispatch(action.loadCheckinOut());
    dispatch(action.loadMonthlyRecord());
    dispatch(action.loadAttendence());
  }, [dispatch])



  const attendenceUpdate = useSelector(state => state.Attendence);
  const { checkinOut_list = [], monthly_list = {}, attendence_list = [] } = attendenceUpdate;

  const [attendanceAction, setAttendanceAction] = useState(null);


  // time section

  const timeRef = useRef(new Date());
  const timeDisplayRef = useRef();

  useEffect(() => {
    const intervalId = setInterval(() => {
      timeRef.current = new Date();
      if (timeDisplayRef.current) {
        // Update DOM directly with formatted time
        timeDisplayRef.current.textContent = moment(timeRef.current).format("hh:mm:ss A");
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  //table data
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (attendence_list?.length) {
      const data = attendence_list.map((entry, index) => {
        const row = {
          sno: index + 1,
          date: dayjs(entry.date).format("DD/MM/YYYY"),
          login: "",
          lunchOut: "",
          lunchIn: "",
          breakOut: "",
          breakIn: "",
          logout: "",
          totalHours: "",
        };

        entry.records.forEach(({ action, time, workHours }) => {
          switch (action.toLowerCase()) {
            case "login":
              row.login = time;
              break;
            case "lunch out":
              row.lunchOut = time;
              break;
            case "lunch in":
              row.lunchIn = time;
              break;
            case "break out":
              row.breakOut = time;
              break;
            case "break in":
              row.breakIn = time;
              break;
            case "logout":
              row.logout = time;
              row.totalHours = workHours !== "0" ? workHours : "";
              break;
            default:
              break;
          }
        });

        return row;
      });

      setTableData(data);
    }
  }, [attendence_list]);

  //table columns
  const columns = [
    {
      title: <span className="poppins-txt">S.No</span>,
      dataIndex: "sno",
      width: 70,
      className: "poppins-txt-lg",
    },
    {
      title: <span className="poppins-txt">Date</span>,
      dataIndex: "date",
      width: 120,
      className: "poppins-txt-lg",
    },
    {
      title: <span className="poppins-txt">Login</span>,
      dataIndex: "login",
      width: 120,
      className: "poppins-txt-lg",
    },
    {
      title: <span className="poppins-txt">Lunch Out</span>,
      dataIndex: "lunchOut",
      width: 120,
      className: "poppins-txt-lg",
    },
    {
      title: <span className="poppins-txt">Lunch In</span>,
      dataIndex: "lunchIn",
      width: 120,
      className: "poppins-txt-lg",
    },
    {
      title: <span className="poppins-txt">Break Out</span>,
      dataIndex: "breakOut",
      width: 120,
      className: "poppins-txt-lg",
    },
    {
      title: <span className="poppins-txt">Break In</span>,
      dataIndex: "breakIn",
      width: 120,
      className: "poppins-txt-lg",
    },
    {
      title: <span className="poppins-txt">Logout</span>,
      dataIndex: "logout",
      width: 120,
      className: "poppins-txt-lg",
    },
    {
      title: <span className="poppins-txt">Total Working Hours</span>,
      dataIndex: "totalHours",
      width: 160,
      className: "poppins-txt-lg",
      render: (text) => <strong>{text}</strong>,
    }

  ];
  //monthly report
  const leaveData = {
    "No. of Leave": monthly_list.leaveDays ?? "",
    "CL": monthly_list.CL ?? "",
    "SL": monthly_list.SL ?? "",
    "No of Permission": `${monthly_list.PermissionCount ?? ""} (${monthly_list.utilizedPermissionHours ?? ""} hrs)`,
    "LOP": `${monthly_list.lopDays ?? ""} (${monthly_list.lopHours ?? ""} hrs)`,
  };

  // getting lat and long
  const [location, setLocation] = useState({ lat: null, lon: null });


  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation({
            lat: position.coords.latitude,
            lon: position.coords.longitude
          });
        },

      );
    }
  }, []);

  const [disabled, setDisabled] = useState(false);
  const [loader, setLoader] = useState(false);
  // handle submit employee 
  const handleSubmit = (e) => {
    e.preventDefault();


    if (attendanceAction && !isEmpty(attendanceAction.value)) {
      setDisabled(true);
      setLoader(true);// Disable the button
      setTimeout(() => {
        setDisabled(false);
        setLoader(false); // Re-enable after 4 seconds
      }, 4000);
      const employeePayload = {

        "actionId": attendanceAction.value,
        "latitude": location.lat,
        "longitude": location.lon

      };

      api
        .post("/auth/attendance/addattendance", employeePayload)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {

            dispatch(action.loadAttendence());
            toast.success(response.data.message || "Action successfully added");
            setAttendanceAction(null);
          } else {
            toast.warning(response?.data?.msg || "Someting went wrong");
          }

          return response.data;
        })
        .catch((err) => {
          const errorMsg =
            err?.response?.data?.message ||
            "An error occurred while adding the Employee";
          toast.error(errorMsg);
          return Promise.reject(err);
        });
    }


  };

  //download csv
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });

    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  const [downloadLoader, setDownloadLoader] = useState(false);

  const exportToCsv = () => {
    setDownloadLoader(true);

    try {
      setTimeout(() => {
        try {
          // === Attendance CSV ===
          const attendanceHeaders = [
            "S.No", "Date", "Login", "Lunchout", "Lunchin", "Break Out", "Break In", "Logout", "Total Working Hours"
          ];

          const attendanceCsvContent = tableData.reduce((acc, item) => {
            const {
              sno,
              date,
              login,
              lunchOut,
              lunchIn,
              breakOut,
              breakIn,
              logout,
              totalHours
            } = item;

            acc.push([
              sno ?? "--",
              date ?? "--",
              login || "--",
              lunchOut || "--",
              lunchIn || "--",
              breakOut || "--",
              breakIn || "--",
              logout || "--",
              totalHours || "--"
            ]);

            return acc;
          }, []);

          const attendanceCsvString = [attendanceHeaders.join(","), ...attendanceCsvContent.map(row => row.join(","))].join("\n");

          downloadFile({
            data: attendanceCsvString,
            fileName: "attendance.csv",
            fileType: "text/csv",
          });

          // === Leave Data CSV without header ===
          const leaveData = {
            "No. of Leave": monthly_list.leaveDays,
            "CL": monthly_list.CL,
            "SL": monthly_list.SL,
            "No of Permission": `${monthly_list.PermissionCount} (${monthly_list.utilizedPermissionHours} hrs)`,
            "LOP": `${monthly_list.lopDays} (${monthly_list.lopHours} hrs)`,
          };

          const leaveCsvContent = Object.entries(leaveData).map(([key, value]) => [
            key,
            value ?? "--"
          ]);

          const leaveCsvString = leaveCsvContent.map(row => row.join(",")).join("\n");

          downloadFile({
            data: leaveCsvString,
            fileName: "leave_data.csv",
            fileType: "text/csv",
          });

        } catch (error) {
        } finally {
          setDownloadLoader(false);
        }
      }, 1000);
    } catch (err) {
      setDownloadLoader(false);
    }
  };
  const actionSequence = [
    "login",
    "lunchOut",
    "lunchIn",
    "breakOut",
    "breakIn",
    "logout",
  ];

  const actionMap = {
    login: "login",
    logout: "logout",
    lunchout: "lunchOut",
    lunchin: "lunchIn",
    breakout: "breakOut",
    breakin: "breakIn",
  };

  // Step 1: Find today’s record
  const todayDateKey = dayjs().format("DD/MM/YYYY");
  const todayRow = tableData.find((row) => row.date === todayDateKey) || {};

  // Step 2: Find last completed action index
  const lastCompletedIndex = actionSequence.findIndex((action) => !todayRow[action]) || 0;

  // Step 3: Generate dropdown options
  const attendanceOptions = !isEmpty(checkinOut_list)
    ? checkinOut_list.map((item) => {
      const normalized = item.actionName.toLowerCase().replace(/\s+/g, "");
      const key = actionMap[normalized];
      const actionIndex = actionSequence.indexOf(key);

      return {
        label: item.actionName,
        value: item._id,
        disabled: actionIndex !== lastCompletedIndex, // only next action is enabled
      };
    })
    : [];


  return (
    <React.Fragment>
      <div className="pl-5">
        <MetaTags>
          <title>Attendence | Mequals</title>
        </MetaTags>
      </div>

      <Row justify="space-between" className="mr-4">
        <Col>
          <BreadcrumbComponent title="Attendence" items={BCrumb} />
        </Col>

        <Col span={24}>
          <Row gutter={16}>
            <Col xs={24} sm={24} md={24} lg={16}>
              <div
                style={{
                  background: "#fff",
                  padding: "16px",
                  marginLeft: "10px",
                }}
              >
                <Row gutter={16}>
                  <Col xs={24} sm={24} md={24} lg={15}>
                    <div className="shadow-lg">
                      <Card
                        style={{
                          background: "#1d2646",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "white",
                          height: "180px",
                        }}
                      >
                        <div style={{ width: "300px" }}>
                          <div
                            className=" date-display"
                            style={{ fontSize: "20px" }}
                          >
                            {moment().format("DD-MM-YYYY")}
                          </div>
                          <div
                            className="time-display"
                            style={{ fontSize: "50px" }}
                          >
                            <p ref={timeDisplayRef}>{moment(timeRef.current).format("hh:mm:ss A")}</p>
                          </div>
                        </div>
                      </Card>
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={9} className="mt-md">
                    <Card style={{ padding: 0, boxShadow: "none" }}>
                      <div
                        className="mb-2 "
                        style={{ marginTop: "-10px", marginLeft: "-12px" }}
                      >
                        <Typography className="poppins-txt">
                          Checkin/Checkout
                        </Typography>
                      </div>
                      <Select
                        placeholder="Select checkin/checkout"
                        allowClear
                        className="custom-select"
                        name="attendanceAction"
                        value={attendanceAction}
                        onChange={(event, newValue) => setAttendanceAction(newValue)}
                        options={attendanceOptions}
                        style={{ marginTop: "-10px", marginLeft: "-12px" }}
                      />
                      <div style={{ display: "flex", justifyContent: "end" }}>
                        <Button
                          className="custom-btn submit-btn"
                          type="primary"
                          size="medium"
                          disabled={disabled}
                          onClick={handleSubmit}
                        >
                          Submit
                        </Button>
                      </div>
                    </Card>
                  </Col>
                </Row>
              </div>
            </Col>

            <Col xs={24} sm={24} md={24} lg={8} className="mt-md">
              <div
                style={{
                  background: "#fff",
                  padding: "16px",
                  marginLeft: "10px",
                }}
              >
                <Card
                  style={{
                    background: "#f54988",
                    color: "white",
                    height: "180px",

                  }}

                >

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                      fontSize: "13px",
                      color: "white"
                    }}
                    className="poppins-txt"
                  >
                    {Object.entries(leaveData).map(([label, value]) => (
                      <div key={label} style={{ display: "flex", whiteSpace: "nowrap" }}>
                        <div style={{ width: "180px" }}>{label}</div>
                        <div>{value}</div>
                      </div>
                    ))}
                  </div>
                </Card>
              </div>
            </Col>
          </Row>
        </Col>

        <Col span={24} style={{ padding: "20px 0 10px 10px" }}>
          <div
            style={{
              background: "#ffffff",
              padding: "20px",
            }}
          >
            <Row justify="end" align="middle" style={{ marginBottom: 10 }}>
              <Col>
                <Button
                  className="custom-btn"
                  size="medium"
                  type="primary"
                  icon={<DownloadOutlined />}
                  onClick={exportToCsv}
                  loading={downloadLoader}
                >
                  Download
                </Button>
              </Col>
            </Row>

            <Table
              loading={loader}
              columns={columns}
              dataSource={tableData}
              className="poppins-txt"
              rowKey={(record) => record._id}
              rowClassName={"text-[12px]"}
              pagination={{
                defaultPageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ["5", "10", "20", "30"],
                showTotal: (total, range) =>
                  `${range[0]}-${range[1]} of ${total}`,
              }}
              sortDirections={"ascend"}
              showSorterTooltip={"sorter-icon"}
              scroll={{
                x: 765,
              }}
            />
          </div>
        </Col>
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};
//AttendenceDetails
export default AttendenceDetails;
